import { render } from "./RegisterPatient.vue?vue&type=template&id=3e49e92d"
import script from "./RegisterPatient.vue?vue&type=script&lang=js"
export * from "./RegisterPatient.vue?vue&type=script&lang=js"
script.render = render

export default script